module.exports = __webpack_public_path__ + "media/wan-prá-yài ná.b535a5db.mp3";